import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "component/UseAuth";

const BookingDetail = ({ booking, onStatusBooking, onBack }) => {
  const { user } = useAuth();

  const isHotel = booking?.category_id === "CAT-HOTEL";
  const isPending = booking?.status === "PENDING";
  const isAdmin = user?.jabatan === "SUPERADMIN" || user?.jabatan === "ADMIN";

  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState("");
  const [loadingRoom, setLoadingRoom] = useState(false);

  /* =============================
     🔥 FETCH AVAILABLE ROOMS
     ============================= */
  useEffect(() => {
    if (!isHotel || !isPending || !isAdmin) return;

    const fetchRooms = async () => {
      try {
        setLoadingRoom(true);

        const res = await axios.post(
          `${process.env.REACT_APP_API}/available-rooms`,
          {
            item_id: booking.item_id,
            start_date: booking.booking_start_date,
            end_date: booking.booking_end_date,
          }
        );
        setRooms(res.data?.data || []);
      } catch (err) {
        console.error("Fetch available rooms error:", err);
      } finally {
        setLoadingRoom(false);
      }
    };

    fetchRooms();
  }, [isHotel, isPending, isAdmin, booking]);

  return (
    <>
      {/* Tombol Back */}
      <div className="mb-3">
        <button className="btn btn-outline-secondary" onClick={onBack}>
          ← Kembali
        </button>
      </div>

      <div className="card p-4 mb-4 shadow-sm">
        <h4 className="mb-4">Detail Booking</h4>
        <div className="row">
          {/* Bukti Transfer */}
          <div className="col-md-4 text-center mb-3">
            <img
              src={`${process.env.REACT_APP_API}/images/${booking.proof_payment}`}
              alt="Bukti Transfer"
              className="img-fluid rounded border"
            />
          </div>

          {/* Detail */}
          <div className="col-md-8">
            <Info label="No. Invoice" value={booking.no_invoice} />
            <Info label="Nama Tamu" value={booking.guest_name} />
            <Info label="Tanggal Booking" value={booking.booking_date} />
            <Info label="Durasi" value={`${booking.duration} malam`} />
            <Info label="Item" value={booking.item_title} />
            {isHotel && !isPending && (
              <>
                <Info label="Nomor Kamar" value={booking.room_number || "-"} />
                <Info label="Lantai Kamar" value={booking.floor || "-"} />
              </>
            )}
            <Info label="Sub Total" value={`Rp ${booking.price.toLocaleString()}`} />
            <Info label="Diskon" value={`Rp ${booking.discount.toLocaleString()}`} />
            <Info label="Total Bayar" value={`Rp ${booking.total.toLocaleString()}`} />
            <Info label="Bank Pengirim" value={booking.bank_from} />
            <Info label="Nama Pengirim" value={booking.account_holder} />

            <Info
              label="Status"
              value={
                <span
                  className={`badge bg-${
                    booking.status === "PENDING"
                      ? "warning"
                      : booking.status === "ACCEPTED"
                      ? "success"
                      : "danger"
                  }`}
                >
                  {booking.status}
                </span>
              }
            />

            {/* =============================
               🔥 PILIH KAMAR (HOTEL + PENDING)
               ============================= */}
            {isHotel && isPending && isAdmin && (
              <div className="mt-3 col-md-8">
                <label className="fw-bold mb-1">Pilih Kamar</label>
                <select
                  className="form-select"
                  value={selectedRoom}
                  onChange={(e) => setSelectedRoom(e.target.value)}
                  disabled={loadingRoom}
                >
                  <option value="">-- Pilih Kamar --</option>
                  {rooms.map((r) => (
                    <option key={r.room_id} value={r.room_id}>
                      Kamar {r.room_number} (Lantai {r.floor})
                    </option>
                  ))}
                </select>

                {!loadingRoom && rooms.length === 0 && (
                  <small className="text-danger">
                    Tidak ada kamar tersedia
                  </small>
                )}
              </div>
            )}

            {/* =============================
               🔥 ACTION BUTTON
               ============================= */}
            {isPending && isAdmin && (
              <div className="mt-4 d-flex gap-2">
                <button
                  className="btn btn-success"
                  disabled={isHotel && !selectedRoom}
                  onClick={() =>
                    onStatusBooking(
                      booking.no_invoice,
                      "accept",
                      selectedRoom
                    )
                  }
                >
                  Accept
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() =>
                    onStatusBooking(booking.no_invoice, "reject")
                  }
                >
                  Reject
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

/* =============================
   🔹 COMPONENT BANTUAN
   ============================= */
const Info = ({ label, value }) => (
  <div className="mb-2 row">
    <label className="col-sm-4 fw-bold">{label}</label>
    <div className="col-sm-8">{value}</div>
  </div>
);

export default BookingDetail;
